/**
 * File: createTpActivity.js
 * Project: educore
 * Created Date: 2018-01-17
 * Author: Raziya S
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
class createTpActivityController {
    // @ngInject
    constructor($scope, $state, $rootScope, authService, localStorageService, archiveService, TPWIZARDCONSTANT) {
        //On init function
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }
        let resourceId = $state.params.resourceId
        let userId = localStorageService.get('user_id')
        let authoring = localStorageService.get('authoringData')
        authService.callAPI(TPWIZARDCONSTANT.API_GET_TP_ACTIVITY + resourceId, "GET", {}, (response) => {
            if (response.result && response.result.data && response.result.data.data) {
                let resultData = response.result.data.data
                if ((resultData.temp_sections && resultData.temp_sections.length > 0) || (resultData.sections && resultData.sections.length > 0)) {
                    $state.go('formatQp', {
                        resourceId: resourceId
                    })
                }
            }
        })
        let authoringData = {
            class_id: authoring.class_id,
            curriculum_id: authoring.curriculum_id,
            batch_id: authoring.batch_id,
            subject_id: authoring.subject_id,
            session_id: authoring.session_id,
            school_id: authoring.school_id,
            batch: authoring.batch,
            class: authoring.class,
            subject: authoring.subject,
            session: authoring.session,
            curriculum: authoring.curriculum,
            academic_year: authoring.academic_year
        }
        $scope.featuresList = [{
            "_id": "createQuestion",
            "name": "Create Question",
            "state": "createQuestion",
            "icon": "../../../img/icons/create-question.png",
            "color": "#f16e02"
        }, {
            "_id": "selectQuestion",
            "name": "Select Question",
            "state": "selectQuestion",
            "icon": "../../../img/icons/select-question.png",
            "color": "#00b4bd"
        }, {
            "_id": "selectTemplate",
            "name": "Select Template",
            "state": "selectTemplate",
            "icon": "../../../img/icons/question-template.png",
            "color": "#f35966"
        }, {
            "_id": "selectQuestionPaper",
            "name": "Select Question Paper",
            "state": "selectQuestionPaper",
            "icon": "../../../img/icons/archives.png",
            "color": "#00ba9c"
        }];

        //Boolean - show/hide the format questions
        $scope.isQuestions = false;

        this.scope = $scope
        this.state = $state
            /*Roles and Privilege*/
        let userAccess = _.filter(localStorageService.get("feature_privileges"), function(feature) {
            return feature.module_state == "activity"
        })
        $scope.activityUserPrivilege = {};
        if (userAccess.length > 0) {
            _.each(userAccess, function(tpObj) {
                let user_access = {};
                _.each(tpObj.privilege, function(privObj) {
                    user_access[privObj.name.toLowerCase()] = privObj.status
                })
                $scope.activityUserPrivilege[tpObj.feature_id] = user_access;
            })
        }
        $scope.teachingPlan = localStorageService.get("currentPlan")
        let currentResource = _.find($scope.teachingPlan.resources, function(resource) {
            return resource._id == resourceId
        });
        if (currentResource)
            $scope.isPractice = currentResource.isPractice
        let theme_id = $scope.teachingPlan.theme_id
        authoringData['theme_id'] = $scope.teachingPlan.theme_id
        authoringData['question_paper_title'] = currentResource.title
        authoringData['practice_qn'] = $scope.teachingPlan.isPractice
        authoringData['user_id'] = userId
        authoringData['activity_id'] = resourceId
        authoringData['plan_id'] = $scope.teachingPlan._id
        authoringData['theme_name'] = $scope.teachingPlan.theme_title
        if (currentResource) {
            let redirectDetails = archiveService.getRedirectJson();
            archiveService.clearRedirectJson();
            if (redirectDetails && redirectDetails.returnData) {
                let details = {
                    activity: currentResource,
                    teachingPlanId: $scope.teachingPlan._id,
                    themeId: $scope.teachingPlan.theme_id
                }
                if (redirectDetails.activeTab == "qp") {
                    let archiveQpId = redirectDetails.returnData.resource._id;
                    authoringData["archive_qp_id"] = archiveQpId
                    authService.callAPI(TPWIZARDCONSTANT.API_SELECT_QP, "POST", authoringData, (response) => {
                        if (response.result && response.result && response.result.data) {
                            let qpId = response.result.data._id
                            $state.go('tpActivityPreview', {
                                qpId: qpId
                            })
                        }
                    })
                } else if (redirectDetails.activeTab == "question") {
                    let ques_ids = [];
                    _.each(redirectDetails.returnData, function(questionArchive) {
                        ques_ids.push(questionArchive.resource._id)
                    })
                    authoringData['ques_ids'] = ques_ids
                    authService.callAPI(TPWIZARDCONSTANT.API_SELECT_QUESTION, "POST", authoringData, (response) => {
                        if (response.result && response.result && response.result.data) {
                            $state.go('formatQp', {
                                resourceId: resourceId
                            })
                        }
                    })
                } else if (redirectDetails.activeTab == "qp_template") {
                     let qpId = redirectDetails.returnData.resource._id;
                     authoringData["archive_qp_id"] = qpId
                     authService.callAPI(TPWIZARDCONSTANT.API_SELECT_TEMPLATE, "POST", authoringData, (response) => {
                        if (response.result && response.result && response.result.data) {
                            let questioPaperId = response.result.data.data._id
                           $state.go('tpActivityPreview', {
                                qpId: qpId
                            })
                        }
                    })
                }
            }
        }



        var goToArchive = (type, isMultiSelect) => {
            let teachingPlan = $scope.teachingPlan;
            let searchFilters = [];
            let authoring = localStorageService.get('authoringData')
            searchFilters.push({
                type: 'curriculum',
                value: {
                    _id: authoring.curriculum_id,
                    name: authoring.curriculum
                },
                deletable: false,
                visible: false
            });
            searchFilters.push({
                type: 'class',
                value: {
                    _id: authoring.class_id,
                    name: authoring.class
                },
                deletable: false,
                visible: false
            });
            searchFilters.push({
                type: 'subject',
                value: {
                    _id: authoring.subject_id,
                    name: authoring.subject
                },
                deletable: false,
                visible: false
            });
            searchFilters.push({
                type: "tab",
                value: {
                    _id: type.tabId,
                    name: type.name
                },
                deletable: false,
                visible: false
            });
            if ($scope.isPractice && type.searchFilterId == 'qp') {
                searchFilters.push({
                    type: "exam_type",
                    value: {
                        _id: "Practice",
                        name: "Practice Exam"
                    },
                    deletable: false,
                    visible: true
                })
            }
            if (!$scope.isPractice && type.searchFilterId == 'qp') {
                searchFilters.push({
                    type: "exam_type",
                    value: {
                        _id: "Assesment",
                        name: "Assessment Exam"
                    },
                    deletable: false,
                    visible: true
                })
            }
            let details = {
                searchFilters: searchFilters,
                previousState: {
                    state: $state.current.name,
                    params: $state.params
                },
                isMultiSelect: isMultiSelect,
                isPractice: $scope.isPractice,
                activeTab: type.tabId,
                resource: this.resource,
                resourceType: {
                    _id: type.searchFilterId,
                    name: type.name
                },
                isPractice: $scope.isPractice
            }
            archiveService.setRedirectJson(details)
            $state.go("archives");
        }

        $scope.navigatePage = (data) => {
            $scope.selectedActivity = data;
            console.log(data)
                // $scope.showOptions = false;
            switch (data._id) {
                case 'createQuestion':
                    localStorageService.set("createQuesiton", {
                        state: "tpActivity",
                        // qp_id: result._id,
                        qp_title: currentResource.title,
                        activity_id: currentResource._id,
                        theme_id: $scope.teachingPlan.theme_id,
                        teaching_plan_id: $scope.teachingPlan._id,
                        class_id: authoringData.class_id,
                        curriculum_id: authoringData.curriculum_id,
                        subject_id: authoringData.subject_id,
                        batch_id: authoringData.batch_id,
                        session_id: authoringData.session_id,
                        school_id: authoringData.school_id,
                        practice_qn: currentResource.isPractice,
                        academic_year: localStorageService.get("activeAcdYear")
                    })
                    this.state.go("createTpQuestion");
                    break;
                case 'selectQuestionPaper':
                    goToArchive({
                        tabId: "qp",
                        searchFilterId: "qp",
                        name: 'Question Paper'
                    }, false);
                    break;
                case 'selectQuestion':
                    goToArchive({
                        tabId: 'question',
                        searchFilterId: 'question',
                        name: "Questions"
                    }, true);
                    break;
                case 'selectTemplate':
                    goToArchive({
                        tabId: 'qp_template',
                        searchFilterId: 'qp',
                        name: "Question Template"
                    }, false)
                    break;
                default:
                    this.state.go("activityForm");
                    break;
            }
        }


        //On destroy function
        this.$onDestroy = () => {}

    };
}

export default createTpActivityController;



// WEBPACK FOOTER //
// ./src/app/authoring-tool/wizard/controllers/activity/createTpActivity.js